import {PathUrlEnum} from '../../../utils/analytics.utils';
import {AnalyticsService} from '../../../shared/services/analytics/analytics.service';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SellerPJDataPayload} from "../../../shared/models/sellerPj.model";
import CpfHelper from "../../../helpers/cpf.helper";

@Component({
  selector: 'app-seller-resume-pj',
  templateUrl: './seller-resume-pj.component.html',
  styleUrls: ['./seller-resume-pj.component.scss'],
})
export class SellerResumePjComponent implements OnInit {
  @Input() dataCompany = new SellerPJDataPayload();
  @Output() formsComplete = new EventEmitter();
  @Output() dataForms = new EventEmitter();
  declarationForm: FormGroup;
  cep = '00000-000';
  cpf = '999.999.999-99';
  phone = '(99)99999-9999';
  conta = '00000000-0';
  maskCpfCnpj = CpfHelper.maskCpfCnpj;

  constructor(private analyticsService: AnalyticsService) {
  }

  ngOnInit(): void {
    this.initForm();
    this.isFormComplete();
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PJ_SALVAR_FORM);
  }

  initForm() {
    this.declarationForm = new FormGroup({
      hasDeclaration: new FormControl(false, [Validators.requiredTrue]),
    });

    //solucao bug ios
    this.declarationForm.get('hasDeclaration')?.markAsPristine();
    this.declarationForm.get('hasDeclaration')?.markAsTouched();
    this.declarationForm.get('hasDeclaration')?.markAsDirty();
  }

  get hasError(): boolean {
    return (
      ((this.declarationForm.get('hasDeclaration')?.dirty ||
          this.declarationForm.get('hasDeclaration')?.touched) &&
        this.declarationForm.get('hasDeclaration')?.invalid) ??
      false
    );
  }

  isFormComplete() {
    this.declarationForm.statusChanges.subscribe(newStatus => {
      Object.keys(this.declarationForm.controls).forEach(key => {
        (this.dataCompany as any)[key] = this.declarationForm.get(key)?.value;
      });
      this.formsComplete.emit(newStatus.toLowerCase() === 'valid');
      this.dataForms.emit(this.dataCompany);
    });
  }
}
